import { Image } from '@cian/ui-kit';
import { Ticker } from '@cian/adfox-templates';

import * as React from 'react';

import { AdLabel } from '../AdLabel';

import * as styles from './PromoBanner.css';

type PromoBannerProps = {
  image: string;
  hitUrl: string;
  disclaimer: string | undefined;
  withAdLabel: boolean;
};

export const PromoBanner: React.FC<PromoBannerProps> = ({ disclaimer, image, hitUrl, withAdLabel }) => {
  return (
    <a
      data-testid="banner-link"
      href={hitUrl}
      className={styles['container']}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className={styles['content']}>
        <Image data-testid="image" src={image} borderRadius={0} width="100%" />
      </div>

      {!!disclaimer && (
        <div data-testid="banner-disclaimer" className={styles['disclaimer']}>
          <Ticker withBackground text={disclaimer} />
        </div>
      )}

      {withAdLabel && (
        <div className={styles['label']}>
          <AdLabel />
        </div>
      )}
    </a>
  );
};
